import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.find";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { redactKnownPropertyNames } from './redactKnownPropertyNames';
import { redactByRegExpPatterns } from './redactByRegExpPattern';
import { redactRequestProperty } from './redactRequestProperty';
import { redactErrorLikeObjects } from './redactErrorLikeObjects'; // We will iterate through each rule until we find one that's applicable.

var redactionRules = [redactRequestProperty, redactErrorLikeObjects, redactKnownPropertyNames, redactByRegExpPatterns]; // We actually want to allow `any` types in this code.

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * This is the non-recursive version of redact; only meant to be used internally or when the
 * caller is doing the recursion (when implementing your own stringifier for instance).
 */

export var redactWithoutRecursing = function redactWithoutRecursing(key, value) {
  var valueType = _typeof(value); // No need to redact booleans, numbers, undefined, or null.


  if (!value || valueType === 'number' || valueType === 'boolean') {
    return value;
  }

  var applicableRule = redactionRules.find(function (rule) {
    return rule.test(key, value);
  });

  if (applicableRule) {
    if (typeof applicableRule.replacement === 'function') {
      return applicableRule.replacement(value);
    }

    return applicableRule.replacement;
  } // No applicable rules for this value -> nothing to redact. Return as is.


  return value;
};
/**
 * @private 
 */

var redactRecursively = function redactRecursively(key, value, seen) {
  var valueType = _typeof(value); // No need to redact booleans, numbers, undefined, or null.


  if (!value || valueType === 'number' || valueType === 'boolean') {
    return value;
  }

  if (valueType === 'string') {
    return redactWithoutRecursing(key, value);
  }
  /* istanbul ignore else */


  if (valueType === 'object') {
    // Avoid circular references.
    if (seen.has(value)) {
      return '--circular-reference-omitted--';
    }

    seen.add(value);

    if (Array.isArray(value)) {
      return value.map(function (item) {
        return redactRecursively(key, item, seen);
      });
    } // We have a {} on our hands (not an array, not a primitive). We don't want to modify the original. So we'll create
    // a new one.


    var newObj = {}; // Remember, "in" iterates through properties of an object (and "of" through arrays).
    // Anything that doesn't show up as property (hello symbols and other exotica) will simply be omitted.
    // Also eslint, I do want to go into the prototype chain.
    // eslint-disable-next-line no-restricted-syntax, guard-for-in

    for (var propertyName in value) {
      newObj[propertyName] = redactRecursively(propertyName, value[propertyName], seen);
    }

    return newObj;
  } // This part is not expected to be executed ever, since we handle known primitives and objects before this.

  /* istanbul ignore next */


  return value;
};
/**
 * @param key - may be undefined (when redacting primitives).
 * @param value - whatever needs to be redacted.
 */


export var redact = function redact(key, value) {
  var redactedValue = redactWithoutRecursing(key, value);

  if (redactedValue !== value) {
    // In case the value was redacted by something like the request-redaction rule, then no need to dig deeper into it
    // because we expect a redaction rule to return a FULLY redacted value (this may change in the future).
    return redactedValue;
  } // the top level object was not picked up by any redaction rule. Time to redact recursively.


  return redactRecursively(key, value, new Set());
}; // There there eslint, you can enable this rule for the newline that follows.

/* eslint-enable @typescript-eslint/explicit-module-boundary-types */